import initialState from './initial-state';
import { SET_BANNERS, SET_BANNERS_ERROR, RESET_BANNERS_ERROR } from '../actions/action-types';
import { createReducer } from './reducer-creator';

const setBanners = (state, { payload }) => {
  // Ensure payload is an array
  if (!Array.isArray(payload)) {
    console.warn('[Banner Reducer] Payload is not an array:', payload);
    return {
      ...state,
      ready: true,
      error: true,
      raw: [],
      categoriesMainCarousel: [],
      categories: [],
    };
  }

  // Filtrar categorías duplicadas por ID
  const uniqueCategories = payload.reduce((acc, current) => {
    const existingIndex = acc.findIndex((item) => item.categoria.id === current.categoria.id);
    if (existingIndex === -1) {
      acc.push(current);
    }
    return acc;
  }, []);

  // Filtrar categorías por fechas de inicio y finalización
  const now = new Date();
  // Establecer la hora a las 00:00:00 para comparar solo fechas
  now.setHours(0, 0, 0, 0);
  
  const activeCategories = uniqueCategories.filter(item => {
    const fechaInicio = item.categoria.fechaInicio;
    const fechaFin = item.categoria.fechaFin;
    
    if (fechaInicio) {
      const [year, month, day] = fechaInicio.split('-').map(Number);
      const startDate = new Date(year, month - 1, day);
      if (now < startDate) {
        return false;
      }
    }
    
    if (fechaFin) {
      const [year, month, day] = fechaFin.split('-').map(Number);
      const endDate = new Date(year, month - 1, day);
      if (now > endDate) {
        return false;
      }
    }
    
    return true; // La categoría está activa
  });

  const orderedCategories = activeCategories.sort((a, b) => a.categoria.orden - b.categoria.orden);
  let defaultBanner = [];
  let otherBanners = [];

  defaultBanner = orderedCategories
    .filter((item) => item.categoria.default)
    .sort((a, b) => a.categoria.orden - b.categoria.orden);

  otherBanners = orderedCategories.filter((item) => item.categoria.default === false);

  const newResponse = otherBanners.concat(defaultBanner);

  const categoriesMainCarousel = orderedCategories.reduce((acc, cur) => {
    const ubicacion = cur.categoria?.ubicacion;

    const validUbicaciones = [
      'banner-simple-ancho-total',
      'carrusel-3-elementos',
      'carrusel-4-elementos',
      'galeria-ofertas',
      'banner-hover-x4',
      'destacado-2-lugares-75-25',
      '2-banner-ancho-total',
      'video',
    ];

    if (ubicacion && validUbicaciones.includes(ubicacion.nombre)) {
      return acc.concat([cur]);
    }

    return acc;
  }, []);

  return {
    ...state,
    ready: true,
    raw: payload,
    categoriesMainCarousel: categoriesMainCarousel || [],
    categories: newResponse || [],
  };
};

const setBannersError = (state) => {
  return {
    ...state,
    ready: true,
    error: true,
  };
};

const resetBannersError = (state) => {
  return {
    ...state,
    ready: false,
    error: false,
  };
};

export default createReducer(initialState.bannersState, {
  [SET_BANNERS]: setBanners,
  [SET_BANNERS_ERROR]: setBannersError,
  [RESET_BANNERS_ERROR]: resetBannersError,
});
